import { render, staticRenderFns } from "./affordable.vue?vue&type=template&id=065557b4&"
import script from "./affordable.vue?vue&type=script&lang=js&"
export * from "./affordable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports